import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function ApproveAllIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M5.82835 12.0312h7.62475"
          strokeWidth="1"></path>
    <path id="Vector_2" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M5.82835 2.01562h7.62475"
          strokeWidth="1"></path>
    <path id="Vector_3" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round" d="M5.87523 7.02344H13.5"
          strokeWidth="1"></path>
    <path id="Vector_4" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m0.5 12.3676 1.09853 1.1328c0.51693 -1.4849 0.94743 -2.1365 1.92243 -3.0209" strokeWidth="1"></path>
    <path id="Vector_5" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="m0.5 2.38517 1.09853 1.13286c0.51693 -1.48491 0.94743 -2.13651 1.92243 -3.02096" strokeWidth="1"></path>
    <path id="Vector_6" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M0.546722 7.37638 1.64525 8.50924c0.51693 -1.48491 0.94743 -2.13651 1.92243 -3.02096"
          strokeWidth="1"></path>
   </SvgIcon>
}
